import React, { useEffect, useMemo, useState } from 'react';
import { Platform, View } from 'react-native';
import I18n from '../../../../components/shared/i18n/I18n.component';
import ReactDatePicker from '../../../../components/web/ReactDatePicker/ReactDatePicker.component';
import httpService from '../../../../services/http.service';
import Card from '../Card/Card.component';
import { getDefaultYearlyFilter } from '../RepHomePage.utils';

const Form101 = ({ filters, customersFullDataJson }: any) => {
	const [localFilters, setLocalFilters] = useState<any>();
	const [data, setData] = useState<any>();

	const getData = async () => {
		const res = await httpService.api({
			type: 'getRepDashboardForm101',
			data: { f: { ...filters, ...localFilters } },
		});
		setData(res);
	};

	useEffect(() => {
		const tempFilters = sessionStorage.getItem('repDashboardForm101');

		if (tempFilters && tempFilters !== '') {
			setLocalFilters(JSON.parse(tempFilters));
		} else {
			setLocalFilters({
				year: getDefaultYearlyFilter(),
			});
		}
	}, []);

	useEffect(() => {
		if (localFilters?.year.length && filters?.unitIds?.[0]) {
			getData();
		}
	}, [filters, localFilters]);

	const onChange = ({ name, value }: any) => {
		const newData: any = { ...localFilters };
		newData.year = [value.getFullYear()];

		sessionStorage.setItem('repDashboardForm101', JSON.stringify(newData));
		setLocalFilters(newData);
	};

	return (
		<View style={{ paddingVertical: 30, width: 'calc(50% - 12px)' }}>
			<View
				style={{
					flexDirection: 'row-reverse',
					alignItems: 'baseline',
					marginBottom: 8,
				}}
			>
				<I18n weight='600' size={17} style={{ marginLeft: 5 }}>
					repDashboard.form101
				</I18n>
				<I18n size={14} weight='500' style={{ marginBottom: 2 }}>
					repDashboard.units
				</I18n>
			</View>
			<View
				style={{
					zIndex: 100,
					flexDirection: 'row-reverse',
				}}
			>
				<View
					style={{
						width: 130,
						zIndex: 100,
						flexDirection: 'row-reverse',
					}}
				>
					<ReactDatePicker
						onChange={onChange}
						config={
							{
								name: 'year',
								type: '',
								date:
									localFilters && new Date(localFilters.year),
								dashboardViewMode: true,
								showYearPicker: true,
								placeholder: localFilters?.year?.[0],
							} as any
						}
					/>
				</View>
			</View>
			<View
				style={{
					marginTop: 16,
					flexDirection: 'row-reverse',
					...Platform.select({ web: { gap: 24 } }),
				}}
			>
				<Card
					title='repDashboard.form101.reports'
					data={data}
					type='rows'
					width={'calc(100%)'}
					colorsObj={{
						PENDING_EMPLOYEE: 'hsla(280, 35%, 56%, 1)',
						PENDING_EMPLOYER:  'hsla(198, 100%, 45%, 1)',
						APPROVED: 'hsla(210, 73%, 39%, 1)',
						APPROVED_AND_VIEWED: 'hsla(118, 48%, 67%, 1)',
					}}
					navigateTo='repForm101Reports'
					defaultParams={{ ...localFilters, ...filters }}
					moreParams={{
						customersFullData: customersFullDataJson,
					}}
				/>
			</View>
		</View>
	);
};

export default Form101;
